import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/rope-rank/index.vue')

export const IndexRoute: RouteConfig = {
  path: '/activity/rope-rank',
  name: 'activity-rope-rank',
  component: Index,
  meta: {
    title: '中国跳绳段位制考评专题活动',
  },
}

export default [IndexRoute]
